import 'details-polyfill';
